function _generateSpeedThroughWater(speedRange, speedOfInterest) {
  // List is initialized with speedOfInterest
  const speedThroughWater = speedOfInterest;
  for (let i = speedRange[0]; i <= speedRange[1]; i += 0.25) {
    speedThroughWater.push(i);
  }

  // Remove duplicates and sort the list
  const uniqueSpeeds = [... new Set(speedThroughWater.sort((a, b) => a - b))];
  return uniqueSpeeds.join(",");
}

export default function mapKdiagramCalculationDataToJson(data) {
  let windDirection = 0;
  switch (data.windDirection) {
  case "Head Seas":
    windDirection = 0;
    break;
  case "Beam Seas":
    windDirection = 1;
    break;
  case "Following Seas":
    windDirection = 2;
    break;
  }

  const speedsOfInterest = data.speedThroughWater.split(",").map(Number);

  return {
    speedThroughWater: _generateSpeedThroughWater(data.speedRange, speedsOfInterest),
    lowerHeatingValue: data.lowerHeatingValue,
    meanDraft: data.meanDraft,
    trim: data.trim,
    trueWindSpeed: data.trueWindSpeed,
    windDirection: windDirection,
    fouling: data.fouling,
    date: data.date,
    type: "input",
    calcData: false,
    valuesType: "speed",
    stats: false,
    startDate: data.minDate,
    endDate: data.maxDate,
    useLatestFouling: data.useLatestFouling,
  };
}
